import React from 'react'
import MissionAndVision from '../../pages/Home/MissionAndVision'
import WhyDoPeople from '../../pages/Home/WhyDoPeople'
import BlogHome from '../../pages/Home/BlogHome'
import ProjectsSlider from '../../pages/Home/ProjectsSlider'

const Home = () => {
  return (
    <>
    <MissionAndVision/>
    <ProjectsSlider/>
    <BlogHome/>
     {/* Footerden uste */}
    <WhyDoPeople/>
    </>
  )
}

export default Home
